import Ajax from '../ajax'

export default {
  products: (params) => Ajax('get', 'front/item/list', params),
  product: (id) => Ajax('get', `front/item/${id}`)
}
